export const BOGO_I18N_NAMESPACE = '@mc/bogo'
